import { Injectable, inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { CurrentUserService } from './current-user.service';

@Injectable({
  providedIn: 'root',
})
export class HttpHeaderService {
  private currentUserService = inject(CurrentUserService);

  /**
   * Generates authorization and request content headers.
   */
  get(): HttpHeaders {
    const currentUser = this.currentUserService.currentUser();
    if (currentUser?.jwtToken) {
      return new HttpHeaders({
        authorization: `bearer ${currentUser.jwtToken}`,
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
  }
}
